class ProductQuickModal extends HTMLElement {
  constructor() {
    super();

    const this_element = this;
    
    this.detailsContainer = this.querySelector('details');
    this.detailsContainerContent = this.detailsContainer.querySelector('.modal__text');
    this.header = document.querySelector('sticky-header');
    this.cartDrawer = document.querySelector('cart-drawer');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    /*
    this.querySelector('.modal__close-button').addEventListener(
      'click',
      this.close.bind(this)
    );
    */
    document.addEventListener("click", function(e){
      if(e.target.closest("details-modal-product-quick .modal__close-button")){
        e.preventDefault();
        this_element.close();
      }
    });

    //rendered on with page load
    document.querySelectorAll('.product-card__quick-add-to-cart').forEach((openButton) => {
      openButton.addEventListener('click', this.openOnClick.bind(this));
    });

    //dynamic rendered product cardds, section-collection is a custom html tag
    const product_card_positions = 'section-collection, .graphene-main-wrapper, .product-slider, .product-variations, .product-cross-selling__products, .article-template__products';
    document.querySelectorAll(product_card_positions).forEach((productCardWrapper) => {
      productCardWrapper.addEventListener('click', function(e){
        if(e.target.closest('.product-card__quick-add-to-cart')){
          e.preventDefault();
          this_element.openOnClick(e)
        }
      });
    });

    this.addEventListener('click', function(e){
        if(e.target.closest('.product-card__quick-add-to-cart__one-button')){
          e.preventDefault();
          this_element.quickAddToCartOneButton(e);
        }
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onBodyClick(event) {
    if (event.target.classList.contains('modal-overlay')) this.close(false);
  }

  openOnClick(event) {
    var btn = event.target.closest('.product-card__quick-add-to-cart')
    var productId = btn.dataset?.productId;
    var productHandle = btn.dataset?.productHandle;

    this.open(productId, productHandle);
  }

  open(productId, productHandle, modalContent = null){
    if(!productHandle) return false;
/*
    if (!this.classList.contains('header__search') && this.header && this.header.headroom) {
      if( !this.header.classList.contains('header-mobile-bottom') ){
        this.header.headroom.unpin();
      }
    }
*/
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    this.detailsContainer.parentElement.hidden = false;

    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    if(this.detailsContainer.querySelector('[tabindex="-1"]') && this.detailsContainer.querySelector('[tabindex="-1"]')) {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }

    this.renderProductQuickModalContent(productId, productHandle, modalContent);
  }

  close(focusToggle = true) {
    this.detailsContainer.parentElement.hidden = true;
    this.detailsContainer.removeAttribute('open');

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    this.detailsContainerContent.innerHTML = "";
  }

  quickAddToCartOneButton(event) {
    var submitButton = event.target.closest('.product-card__quick-add-to-cart__one-button')
    var productId = submitButton.dataset?.productId;
    var productHandle = submitButton.dataset?.productHandle;
    var variantId = submitButton.dataset?.variantId;
    var alertsWrapper = this.querySelector('.quick-add-to-cart__one-button__alerts_wrapper');
    
    if(!variantId) return false;
    if (submitButton.classList.contains('loading')) return;

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    if(alertsWrapper){
      alertsWrapper.querySelectorAll('.alert').forEach(alert => {
        alert.classList.add('hidden');
        alert.querySelector('.text-content').innerHTML = "";
      })
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      id: variantId,
      sections: this.cartDrawer.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const event = new CustomEvent('click', {
              details: { target: this.cartError }
            });

            //show error message
            if(alertsWrapper && alertsWrapper.querySelector('.alert-danger')){
              alertsWrapper.querySelector('.alert-danger .text-content').innerHTML = response.description;
              alertsWrapper.querySelector('.alert-danger').classList.remove('hidden');
            }
            console.log('product not added:', response.description)
            
            return;
          }

          //show notification
          if(alertsWrapper && alertsWrapper.querySelector('.alert-success')){
            var new_text = alertsWrapper.querySelector('.alert-success .text-content').getAttribute('data-alert-text');
            new_text = new_text.replace("%%product_title%%", response.title);
            
            alertsWrapper.querySelector('.alert-success .text-content').innerHTML = new_text;
            alertsWrapper.querySelector('.alert-success').classList.remove('hidden');
          }

          document.dispatchEvent(new Event('add_to_cart'));
          this.cartDrawer.renderContents(response, "add");

          //tracking codes
            //response.id is the variant of the product
          
            //Graphene track - add to cart
            if(typeof $g != "undefined"){
              $g.track({
                scope           : "basket",
                action          : "add",
                data            : { product_id: response.product_id, quantity: 1 }
              });
            }
          //end tracking codes
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
  }

  renderProductQuickModalContent(productId, productHandle, modalContent){
    /*
      modalContent - by default renders PDP like content; other values:
        "add-to-cart-success" - message after successful add-to-cart with cross-sells
    */
    
    fetch(`/products/${productHandle}?section_id=product-quick-modal`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.detailsContainerContent.innerHTML = responseText;

        if(modalContent == "add-to-cart-success"){
          cartNotificationWithCrossSells();
        }
        else {
            //Graphene track - product view
            if(typeof $g != "undefined"){
              $g.track({
                scope           : "view",
                action          : "add",
                data            : { product_id: productId }
              });
            }
            //end tracking
        }
        
      });
  }
}

customElements.define('details-modal-product-quick', ProductQuickModal);
